<p-toast></p-toast>

<ami-dialog-message [setting]="message"></ami-dialog-message>
<p-dialog
  [(visible)]="open"
  [closeOnEscape]="true"
  [modal]="true"
  showEffect="fade"
  [keepInViewport]="false"
  [draggable]="false"
  [style]="{ width: '90%', height: '100%' }"
  (onHide)="onClose()"
>
  <div class="card">
    <div class="flex justify-content-center">
      <div class="flex align-items-center justify-content-center">
        <div class="p-fluid p-formgrid grid">
          <form [formGroup]="fg">
            <div class="col-12 md:col-11 grid">
              <div class="col-12 md:col-11">
                <span class="block text-3xl font-medium text-900 mt-2"
                  >Registrar Factura de Orden de Compra
                </span>
              </div>
              <div class="col-12 md:col-1 mt-2">
                <pg-cart-purchase-order
                  [itemsInvoice]="true"
                ></pg-cart-purchase-order>
              </div>
              <div class="col-8">
                <p-message
                  severity="info"
                  text="Seleccione la Orden de Compra. Asegurese de ingresar los datos correctamente."
                  styleClass="p-mr-2 "
                ></p-message>
              </div>
              <div class="field col-12 md:col-12 mb-4">
                <pg-purchase-order-details
                  (onSelect)="purchaseOrderSelected.onSelect($event)"
                  [legend]="purchaseOrderSelected.legend"
                  [isInvoice]="true"
                ></pg-purchase-order-details>
              </div>
              <div class="field col-12 md:col-12 mb-4">
                <p-fieldset legend="Detalles" [toggleable]="false">
                  <div class="grid">
                    <div class="field col-12 md:col-6">
                      <label>Fecha de Pago</label>
                      <input
                        pInputText
                        formControlName="issue_at"
                        type="date"
                      />
                    </div>
                    <div class="field col-12 md:col-6">
                      <label>Documento de Factura </label>
                      <input
                        pInputText
                        formControlName="numberDocument"
                        type="text"
                      />
                    </div>
                  </div>
                </p-fieldset>
              </div>
              <div *ngIf="purchaseOrderSelected.getItems()" class="col-12">
                <pg-products-provider
                  [items]="purchaseOrderSelected.getItems()"
                  [isInvoice]="true"
                ></pg-products-provider>
              </div>
            </div>
            <div class="flex justify-content-center card-container mt-3">
              <button
                (click)="onSubmit()"
                pButton
                pRipple
                class="p-button-sg p-button-success"
                pTooltip="Agregar Stock"
                tooltipPosition="bottom"
                style="width: '15%'"
                styleClass="text-center"
              >
                CONFIRMAR OPERACIÓN
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</p-dialog>

<pg-purchase-order-select
  *ngIf="select.purchaseOrder.openDialog"
  (selectedRowsEvent)="onSelectedPurchaseOrder($event)"
></pg-purchase-order-select>
